// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"Page__pageContainer___2R5AL","pageHeader":"Page__pageHeader___3AWbk","pageBodyContainer":"Page__pageBodyContainer___3OgCc","controlPanelContainer":"Page__controlPanelContainer___ytr_f","errorBox":"Page__errorBox___7WEYD"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Page/Page.scss
// module id = 202
// module chunks = 0